import { format } from 'date-fns';

export function dateArrayToString(dateArray: number[], stringFormat: string) {
  if (!dateArray || !dateArray.length || !stringFormat) {
    return '';
  }
  const [year, month, day, hour, minute] = dateArray;
  return format(new Date(year, month - 1, day, hour, minute), stringFormat);
}

export function dateToUnixTimeStampInSeconds(date: Date) {
  return Math.floor(date.getTime() / 1000);
}

export function milisecondsToUnixTimeStampInSeconds(miliseconds: number) {
  return dateToUnixTimeStampInSeconds(new Date(miliseconds));
}

export function getMinutesFromEpoch(epoch: number): number {
  const date = new Date(epoch);
  return date.getMinutes();
}

export function getMsToNextHalfHour(): number {
  const now = new Date();
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();
  const milliseconds = now.getMilliseconds();

  if (minutes < 30) {
    return ((29 - minutes) * 60 * 1000) + ((59 - seconds) * 1000) + (999 - milliseconds);
  } else {
    return ((59 - minutes) * 60 * 1000) + ((59 - seconds) * 1000) + (999 - milliseconds);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/date-utils.ts